import { AJMAN_DISTRICTS } from '../../data/ajmanDistricts';

/**
 * Simple SVG-based map visualization for Ajman districts
 * Shows district rectangles colored by contact count.
 * No Google Maps API needed.
 */
export function DistrictMap({ districtCounts }) {
  if (!districtCounts || districtCounts.length === 0) return null;

  const maxContactCount = Math.max(...districtCounts.map(([, c]) => c));

  // Compute overall bounds for viewBox
  const allLats = AJMAN_DISTRICTS.flatMap(d => [d.bounds.minLat, d.bounds.maxLat]);
  const allLngs = AJMAN_DISTRICTS.flatMap(d => [d.bounds.minLng, d.bounds.maxLng]);
  const minLng = Math.min(...allLngs) - 0.008;
  const maxLng = Math.max(...allLngs) + 0.008;
  const minLat = Math.min(...allLats) - 0.008;
  const maxLat = Math.max(...allLats) + 0.008;
  const lngRange = maxLng - minLng;
  const latRange = maxLat - minLat;

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <svg
        viewBox={`${minLng} ${-maxLat} ${lngRange} ${latRange}`}
        style={{ width: '100%', height: '100%' }}
        preserveAspectRatio="xMidYMid meet"
      >
        {/* Background */}
        <rect x={minLng} y={-maxLat} width={lngRange} height={latRange} fill="#f0f9ff" />
        
        {/* District rectangles */}
        {AJMAN_DISTRICTS.map((district) => {
          const districtData = districtCounts.find(
            ([name]) => name === district.nameAr || name === district.name
          );
          const count = districtData ? districtData[1] : 0;
          const intensity = count > 0 ? count / maxContactCount : 0;

          return (
            <g key={district.name}>
              <rect
                x={district.bounds.minLng}
                y={-district.bounds.maxLat}
                width={district.bounds.maxLng - district.bounds.minLng}
                height={district.bounds.maxLat - district.bounds.minLat}
                fill={
                  count > 0
                    ? `rgba(78, 205, 196, ${0.2 + intensity * 0.6})`
                    : 'rgba(148, 163, 184, 0.15)'
                }
                stroke={count > 0 ? '#4ecdc4' : '#cbd5e1'}
                strokeWidth="0.003"
                rx="0.003"
              />
              {count > 0 && (
                <text
                  x={district.center.lng}
                  y={-district.center.lat}
                  textAnchor="middle"
                  dominantBaseline="central"
                  fill="#ffffff"
                  fontSize="0.025"
                  fontWeight="bold"
                  style={{ textShadow: '0 0 4px rgba(0,0,0,0.7)' }}
                >
                  {count}
                </text>
              )}
            </g>
          );
        })}
      </svg>

      {/* Legend */}
      <div style={{
        position: 'absolute',
        bottom: 8,
        right: 8,
        background: 'rgba(255,255,255,0.95)',
        padding: '8px 12px',
        borderRadius: 8,
        fontSize: 11,
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      }}>
        <div style={{ fontWeight: 700, marginBottom: 4 }}>📊 عدد جهات الاتصال</div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <span>أقل</span>
          <div style={{ 
            width: 80, 
            height: 8, 
            background: 'linear-gradient(90deg, rgba(148,163,184,0.2), rgba(78,205,196,1))',
            borderRadius: 4,
          }} />
          <span>أعلى</span>
        </div>
      </div>
    </div>
  );
}
